import { getHeader } from "h3";
import authMiddleware from "./middleware/auth.mjs";
import { getNitroRouteRules } from "./utils/kit.mjs";
import { addRouteMiddleware, defineNuxtPlugin, useRuntimeConfig, useAuth, useAuthState, _refreshHandler } from "#imports";
export default defineNuxtPlugin(async (nuxtApp) => {
  const { data, lastRefreshedAt, loading } = useAuthState();
  const { getSession } = useAuth();
  const runtimeConfig = useRuntimeConfig().public.auth;
  const routeRules = import.meta.server ? getNitroRouteRules(nuxtApp._route.path) : {};
  let nitroPrerender = false;
  if (nuxtApp.ssrContext) {
    nitroPrerender = getHeader(nuxtApp.ssrContext.event, "x-nitro-prerender") !== void 0;
  }
  let disableServerSideAuth = routeRules.disableServerSideAuth;
  disableServerSideAuth ??= runtimeConfig?.disableServerSideAuth;
  disableServerSideAuth ??= false;
  if (disableServerSideAuth) {
    loading.value = true;
  }
  if (typeof data.value === "undefined" && !nitroPrerender && !disableServerSideAuth) {
    await getSession();
  }
  nuxtApp.hook("app:mounted", () => {
    _refreshHandler.init();
    if (disableServerSideAuth) {
      getSession();
    }
  });
  const _unmount = nuxtApp.vueApp.unmount;
  nuxtApp.vueApp.unmount = function() {
    _refreshHandler.destroy();
    lastRefreshedAt.value = void 0;
    data.value = void 0;
    _unmount();
  };
  const { globalAppMiddleware } = useRuntimeConfig().public.auth;
  if (globalAppMiddleware === true || typeof globalAppMiddleware === "object" && globalAppMiddleware.isEnabled) {
    addRouteMiddleware("auth", authMiddleware, {
      global: true
    });
  }
});
